import _ from 'lodash';

import createModel, { prop } from '../lib/create_model';
import InteractionType from 'models/interaction_type';
import NotificationType from './notification_type';
import { SessionCustomer } from '../active_session';

export default createModel({
  modelName: 'AutoAcceptedSessionNotification',

  properties: {
    id: prop(String).isRequired,
    conversationId: prop(String).isRequired,
    messageText: prop(String),
    profile: prop(SessionCustomer).isRequired,
    sessionType: prop().oneOf(..._.keys(InteractionType)),
  },

  updateMessageText(messageText) {
    this.messageText = messageText;
  },

  updateProfileName(name) {
    this.profile.updateName(name);
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.AUTO_ACCEPTED_SESSION_NOTIFICATION });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/auto_accepted_session_notification.js